import { consumeModalAutoDisplay } from '../../utils/modalAutoDisplay';
import React, { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ResizeHiddenWrapper from "../../components/Common/ResizeHiddenWrapper";
import {
  debounce,
  formatImage,
  getPageSameType,
  isIphoneX,
  isWeixinMobile,
} from "../../utils/util";
import {
  NormalPendant,
  RefreshPendant,
  SettingPendant,
  GoodPendant,
  FindPendant,
} from "./OnePendant";
import { IComponent, IPendantButton as ButtonType } from "../../component.d";
import "./Pendant.scss";
import ComponentLink from "../ComponentLink";
import { IComponentLink, IComponentCommentSend } from "../../component";
import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import stat from "../../utils/stat";
import { hasPhotoLikeComponent } from "../../utils/util";
import { getPendantColor } from "../../utils/color";
import { style } from "../../utils/image";
import intl from "react-intl-universal";
import { ThemeContext } from "../../store/ThemeProvider";
import JigsawPendant from "./JigsawPendant";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import ReactSVG from "react-svg";
// import AllForAppointment from "../Appointment/AllForAppointment";

import classNames from "classnames";
import FindDetail from "../../pages/Person/Detail";
import "../../pages/Person/index.scss";
import useRealBottomTab from "../ComponentNavigator/useRealBottomTab";
import activeGalleryInstance from "../GalleryList/ActiveGalleryInstance";
import {dispatchSetIsEndFalse} from "components/ComponentPendantV2/RefreshButton";

const defaultIcons = [
  // {
  //   key: ButtonType.refresh,
  //   icon: require('../../assets/refresh.png')
  // },
  {
    key: ButtonType.setting,
    icon: require("../../assets/setting.png"),
  },
  // 不存在这个图标了
  // {
  //   key: ButtonType.top,
  //   icon: require('../../assets/to-top.png')
  // },
  {
    key: ButtonType.good,
    icon: require("../../assets/icon-good.png"),
  },
  {
    key: ButtonType.redpackage,
    icon: require("../../assets/icon-redpackage.png"),
  },
];

interface IOneButton {
  show: boolean;
  type: ButtonType;
  image?: string;
  link?: IComponentLink;
  child?: any;
  event?: () => void;
  hide_setting?: boolean;
}

interface IAllForPendant extends IComponent {
  buttons?: IOneButton[];
  rootStore?: RootStore;
}

const canShowRefresh = () => {
  return hasPhotoLikeComponent(window.pageDetail.template || []);
};

const canShowGalleryButtons = () => {
  let { data, video_data } = window.pageDetail;
  if (data) {
    return true;
  }
  return false;
};

const AllForPendant = function (props: IAllForPendant) {
  const { container, rootStore } = props;
  const {
    localeStore,
    redPackStore,
    relationStore,
    uiStore,
    wxuserStore,
  } = rootStore!;
  const activeGallery = activeGalleryInstance.get();
  const loc = intl.getInitOptions().currentLocale;
  const eXBottom = isIphoneX() ? 20 : 0;
  const [realBottom, setRealBottom] = useState(0);

  const [buttons, setButtons] = useState(props.buttons);
  const [zIndex, setZIndex] = useState(3);

  const [showTop, setShowTop] = useState(false);
  const [canShowTop, setCanShowTop] = useState(false);

  const checkShowTop = () => {
    // if (showTop) {
    if (window.scrollY > window.innerHeight - 100) {
      return true;
    }
    // }
    return false;
  };

  // 上来就要检测一下是否应该显示showTop
  useEffect(() => {
    let { template } = window.pageDetail;

    let exist = false;
    (template || []).forEach((it: IComponent) => {
      if (it && it.type == "photo") {
        exist = true;
      }
    });

    if (exist) {
      setShowTop(false);
    } else {
      setShowTop(true);
    }
  }, [showTop]);

  useEffect(() => {
    if (showTop) {
      const scrollHandler = () => {
        let result = checkShowTop();
        setCanShowTop(result);
      };

      window.addEventListener("scroll", scrollHandler);

      return () => {
        window.removeEventListener("scroll", scrollHandler);
      };
    }
  }, [showTop]);

  // 注意，国际化的东西需要放在组件内部，否则在刷新页面前不会生效
  const typeList = [
    {
      type: "1",
      name: intl.get("One Column"),
    },
    {
      type: "2",
      name: intl.get("Two Column"),
    },
    {
      type: "4",
      name: intl.get("Four Column"),
    },
    {
      type: "flow",
      name: intl.get("Timeline"),
    },
  ];

  const [commentSendShow, setCommentSendShow] = useState(true);

  useEffect(() => {
    const eventHandler = (e: Event) => {
      if (e && e.type == "custom-commentsend-show") {
        setCommentSendShow(true);
      }
      if (e && e.type == "custom-commentsend-hide") {
        setCommentSendShow(false);
      }
    };

    window.addEventListener("custom-commentsend-show", eventHandler);
    window.addEventListener("custom-commentsend-hide", eventHandler);

    return () => {
      window.removeEventListener("custom-commentsend-show", eventHandler);
      window.removeEventListener("custom-commentsend-hide", eventHandler);
    };
  }, []);

  useEffect(() => {
    let { template } = window.pageDetail;
    let paddingBottom = isIphoneX() ? 22 : 0;
    let shouldBorder = false;
    const { showNavigator } = useRealBottomTab();
    if (showNavigator) {
      paddingBottom += 49;
      shouldBorder = true;
    }
    const commentsend = getPageSameType(template, [], ["commentsend"]);
    if (commentsend && commentsend.length && commentSendShow) {
      paddingBottom += 66;

      // if (
      //   commentsend[0] &&
      //   Number((commentsend[0] as IComponentCommentSend).emotion)
      // ) {
      //   paddingBottom += 73;
      //   shouldBorder = true;
      // }
    }

    if (shouldBorder) {
      paddingBottom += 15;
    }

    setRealBottom(Math.max(15, paddingBottom));
  }, [commentSendShow]);

  useEffect(() => {
    setButtons((prevState) => {
      const btns = prevState || ([] as IOneButton[]);
      //btns.push({ type: ButtonType.jigsaw, show: true });
      return btns;
    });
  }, []);

  const toTop = () => {
    // (document.querySelector('.gallery-home')!
    //   .parentNode! as HTMLDivElement).scrollTop = 0;
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const clickRefresh = debounce(() => {
    toTop();

    let oldTotal = activeGallery ? activeGallery.total : 0;

    if (!activeGallery) return;
    // @ts-ignore
    activeGallery.reload({ notmerge: true }).then((res: any) => {
      dispatchSetIsEndFalse();
      if (res && res.total) {
        if (oldTotal >= res.total) {
          uiStore.showToast({ content: intl.get("NoMorePhoto") });
        } else {
          uiStore.showToast({
            content: intl.get("MorePhoto", {
              num: res.total - oldTotal,
            }),
          });
        }
      }
    });
  });
  const clickCustom = (link?: IComponentLink) => {
    if (link && link.type && link.type == "modal-image") {
      let newModalMap = {
        ...modalMap,
        [String(link.modalcontent)]: true,
      };
      setModalMap(newModalMap);
      disableBodyScroll(document.body);
    } else {
      link && ComponentLink.to(link);
    }
  };
  const defaultClick = () => {
    console.log("default click");
  };
  const redPacketClick = () => {
    redPackStore.setSendModal(true);
  };
  const settingTypeClick = (type: string) => {
    activeGallery?.setMode(type);
  };
  const settingOrderClick = () => {
    toTop();
    activeGallery?.setOrder();
    stat.event("button_sort");
    activeGallery?.reload({ orderchange: true, notmerge: true });
  };
  const settingLanClick = () => {
    localeStore.setLocale(loc === "zh-CN" ? "en-US" : "zh-CN");
    stat.event("button_locale");
  };
  const preorderClick = () => {
    window.location.href = "/page/order/" + window.pageDetail.link_id;
  };
  const { right = 0, bottom = 0 } = container || {};

  let wrapper = { right, bottom: +realBottom };

  const { mode = '1', order = 'asc' } = activeGallery || {};
  const currentTypeIndex = typeList.findIndex((type) => type.type === mode);
  const filteredTypeList = [
    ...typeList.slice(0, currentTypeIndex),
    ...typeList.slice(currentTypeIndex + 1),
  ];

  const { h1Color, mainColor, componentColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  useEffect(() => {
    const notifyButtonsChange = (e: any) => {
      let eButtons = (e.buttons || []) as IOneButton[];
      let action = (e.action || "") as string;
      if (action == "event") {
        setButtons(
          eButtons.map((btn: any) => {
            return {
              type: btn.eventType || "event",
              show: true,
              child: btn.child,
              event: btn.event,
            } as IOneButton;
          })
        );
      }

      if (action == "tab_no_photo") {
        setButtons(
          (buttons || []).map((btn: any) => {
            if (btn && btn.type == "jigsaw") {
              btn.show = false;
            }
            if (btn && btn.type == "setting") {
              // btn.show = false;
              btn.hide_setting = true;
            }

            return btn;
          })
        );
        setShowTop(true);
      }
      if (action == "tab_has_photo") {
        setShowTop(false);
        setCanShowTop(false);
        setButtons(
          (buttons || []).map((btn: any) => {
            if (btn && btn.type == "jigsaw") {
              btn.show = true;
            }
            if (btn && btn.type == "setting") {
              // btn.show = true;
              btn.hide_setting = false;
            }

            return btn;
          })
        );
      }

      if (action == "reset") {
        setButtons(props.buttons);
        setZIndex(3);
        setShowTop(true);
      }

      if (action == "zindex") {
        setZIndex(Number(e.data));
      }
    };

    window.addEventListener("PENDENT_CHANGE", notifyButtonsChange);

    return () => {
      window.removeEventListener("PENDENT_CHANGE", notifyButtonsChange);
    };
  }, []);

  const modalButtons = (buttons || []).filter((btn, index) => {
    return btn && btn.link && btn.link.type == "modal-image";
  });

  useEffect(() => {
    // 检测一下有没有需要自动弹出的内容
    if (modalButtons && modalButtons.length) {
      modalButtons.forEach((btn, index) => {
        if (btn && btn.link && btn.link.modalauto) {
          if (consumeModalAutoDisplay(btn.link)) {
            let newModalMap = {
              ...modalMap,
              [String(btn.link.modalcontent)]: true,
            };
            setModalMap(newModalMap);
            disableBodyScroll(document.body);

          }
        }
      });
    }
  }, [modalButtons && modalButtons.length]);
  const [modalMap, setModalMap] = useState({} as any);

  const isChinese = intl.getInitOptions().currentLocale === "zh-CN";

  const [showFindResult, setShowFindResult] = useState(false);

  useEffect(() => {
    const showFindHandler = () => {
      setShowFindResult(true);

      const loc = intl.getInitOptions().currentLocale;
      const cls = classNames("icon", { en: loc !== "zh-CN" });

      let event = new Event("PENDENT_CHANGE");
      event.buttons = [
        {
          child: (
            <div className="pendent-normal followee-detail-return">
              <div className={cls} />
            </div>
          ),
          event: () => {
            let zindexEvent = new Event("PENDENT_CHANGE");
            event.action = "reset";
            window.dispatchEvent(event);
            setShowFindResult(false);
          },
        },
      ];
      event.action = "event";
      window.dispatchEvent(event);
    };

    window.addEventListener("show-find-people-result", showFindHandler);

    return () => {
      window.removeEventListener("show-find-people-result", showFindHandler);
    };
  }, [showFindResult]);

  return createPortal(
    <ResizeHiddenWrapper>
      <div
        className="pendant v1"
        style={{
          ...wrapper,
          zIndex,
        }}
      >
        {canShowTop ? (
          <NormalPendant
            svg={
              <ReactSVG
                src={require("../../svg/to-top.svg")}
                style={{
                  color: pendantIconColor,
                  width: 14,
                  height: 19,
                }}
              />
            }
            style={{ width: `36px`, height: `36px` }}
            onClick={() => {
              window.scrollTo({
                left: 0,
                top: 0,
                behavior: "smooth",
              });
            }}
            key={"to-top"}
          />
        ) : null}
        {buttons &&
          buttons
            .map((btn, index) => {
              const { type, image = "", link, show, child, event } = btn;
              const icons = defaultIcons.find((icon) => icon.key === type);
              const src = icons ? icons.icon : "";
              if (!show) {
                return null;
              }
              switch (btn.type) {
                case ButtonType.order:
                  return (
                    <NormalPendant
                      key="preorder"
                      text={intl.get("Preorder")}
                      onClick={preorderClick}
                    />
                  );
                case ButtonType.people:
                  // 找人功能按钮
                  return <FindPendant key={index} rootStore={rootStore} />;
                case ButtonType.share:
                  // 后续增加分享功能
                  return null;
                case ButtonType.good:
                  return (
                    <GoodPendant
                      key={index}
                      src={image ? formatImage(image, "wx_icon_32") : src}
                    />
                  );
                case ButtonType.refresh:
                  return canShowRefresh() ? (
                    <RefreshPendant
                      notification={activeGallery ? activeGallery.morePhoto : 0}
                      onClick={clickRefresh}
                      key={index}
                    />
                  ) : null;
                case ButtonType.custom:
                  return (
                    <NormalPendant
                      src={style(image, "avatar_150")}
                      onClick={() => clickCustom(link)}
                      key={index}
                    />
                  );
                case ButtonType.jigsaw:
                  return canShowGalleryButtons() ? (
                    <JigsawPendant key={index} />
                  ) : null;
                case ButtonType.setting:
                  return (
                    <React.Fragment key={ButtonType.setting}>
                      <NormalPendant
                        text={isChinese ? "En" : "中"}
                        onClick={settingLanClick}
                        style={{ fontSize: 14 }}
                      />
                      {canShowGalleryButtons() && !btn.hide_setting ? (
                        <SettingPendant
                          typeList={filteredTypeList}
                          order={order}
                          key={index}
                          typeClick={settingTypeClick}
                          orderClick={settingOrderClick}
                          // lanClick={settingLanClick}
                        />
                      ) : null}
                    </React.Fragment>
                  );
                case ButtonType.event:
                  return (
                    <div
                      key={"event" + index}
                      className="pendant-row"
                      onClick={event}
                    >
                      {child}
                    </div>
                  );
                case ButtonType.redpackage:
                  // if (!isWeixinMobile()) {
                  //   console.log(
                  //     '当前设定了红包挂件，但是不是微信手机浏览器，所以不显示'
                  //   );
                  //   return null;
                  // }
                  return (
                    <NormalPendant
                      className="pendant-redpackage"
                      src={image ? formatImage(image, "wx_icon_32") : src}
                      onClick={redPacketClick}
                      key={index}
                    />
                  );
                default:
                  return (
                    <NormalPendant
                      src={image ? formatImage(image, "wx_icon_32") : src}
                      onClick={defaultClick}
                      key={index}
                    />
                  );
              }
            })
            .filter(Boolean)}
      </div>
      {modalButtons && modalButtons.length ? (
        <>
          {modalButtons.map((btn, index) => {
            return (
              <div
                className={
                  "pendent-modal " +
                  (modalMap[`${btn.link!.modalcontent}`] ? "show" : "")
                }
                key={index}
              >
                <div className="wrapper">
                  <img src={style(btn.link!.modalcontent, "wx_560_n")} />
                </div>
                <div
                  className="close"
                  onClick={() => {
                    let newModalMap = {
                      ...modalMap,
                      [String(btn.link!.modalcontent)]: false,
                    };
                    clearAllBodyScrollLocks();
                    setModalMap(newModalMap);
                  }}
                >
                  <img src={require("../../assets/x-white.png")} />
                </div>
              </div>
            );
          })}
        </>
      ) : null}
      {showFindResult ? (
        <div className="pendant-find-result all-for-pageperson">
          <FindDetail
            person={relationStore.find}
            personAlbum={relationStore.findAlbum}
            useConfigShare={true}
          />
        </div>
      ) : null}
    </ResizeHiddenWrapper>,
    document.body
  );
};

export default inject("rootStore")(observer(AllForPendant));
